export const chats = {
  chatListChatIfoAttachmentsText: 'Отправлено вложение',
  chatListChatNoMessagesText: 'Сообщений пока нет',
  chatArchivedTitle: 'Архив чатов',
  chatsCreatePrivateCurtainTitle: 'Новый чат',
  chatsCreatePrivateCurtaiSearchInputPlaceholder: 'Поиск',
  chatsCreatePrivateCurtainCreateButtonTitle: 'Создать',
  chatCreateButtonTitle: 'Далее',
  chatCreateNewGroupHeader: 'Новая группа',
  chatGroupNameInputTitle: 'Название группы',
  chatLogoTitle: 'Изменить',
  chatCreateGroupButtonTitle: 'Создать группу',
  chatRequiredFieldsAlert: 'Укажите название группы!',
  chatsCreateGroupChatLongTitleAlertText: 'Название слишком длинное!',
  chatsCreateGroupChatLBigImageAlertText: 'Изображение слишком большое!',
  chatsNewChatInputPlaceholder: 'Написать сообщение',
  chatsNewChatAddedBigImageAlertText: 'Изображение слишком большое!',
  chatOwnersArchiveOptionText: 'Переместить в архив',
  chatOwnersEditGroupOptionText: 'Изменить',
  chatOwnersManageGroupOptionText: 'Список участников',
  chatOwnersChangeGroupOptionText: 'Изменить владельца группы',
  chatOwnersLeaveGroupOptionText: 'Покинуть чат',
  chatOwnersDeleteGroupOptionText: 'Удалить чат',
  chatpopupArchivedTitle: 'Добавить в архив',
  chatpopupArchivedDescription: 'Вы уверены?',
  chatArchiveGroupButtonTitleYes: 'Подтвердить',
  chatArchiveGroupButtonTitleCancel: 'Отменить',
  chatEditGroupHeader: 'Редактировать чат',
  chatEditGroupEditLogoTitle: 'Изменить',
  chatEditGroupButtonTitle: 'Сохранить',
  chatGroupEditAlertText: 'Успешно сохранено!',
  chatManageGroupHeader: 'Список участников',
  chatManageGroupButtonTitle: 'Добавить участника',
  chatManageGroupSaveButtonTitle: 'Сохранить',
  chatAddUsersGroupHeader: 'Добавить участников',
  chatAddUsersGroupButtonTitle: 'Подтвердить',
  chatAddUsersGroupSearchInputPlaceholder: 'Поиск',
  chatOwnershipTransferHeader: 'Изменение владельца',
  chatOwnershipTransferSearchInputPlaceholder: 'Поиск',
  chatOwnershipTransferButtonTitle: 'Подтвердить',
  chatOwnerMarkText: '(Вы)',
  chatOwnershipTransferAlertText: 'Владелец изменен!',
  chatOwnerLeaveGroupTitle: 'Покинуть чат',
  chatOwnerLeaveGroupDescription: 'Вы являетесь владельцем группы, поэтому сначала нужно выбрать нового владельца.',
  chatOwnerLeaveGroupButtonTitleYes: 'Выбрать',
  chatOwnerLeaveGroupButtonTitleNo: 'Отменить',
  chatsGroupChatUsersCurtanArchOptionTitle: 'Переместить в архив',
  chatsGroupChatUsersCurtanMembersOptionTitle: 'Участники чата',
  chatsGroupChatUsersCurtanLeaveOptionTitle: 'Покинуть чат',
  chatsGroupChatMemberCurtainTitle: 'Участники чата',
  chatsGroupChatMemberCurtainSearchInputPlaceholder: 'Поиск',
  chatsGroupChatMemberCurtainOwnerMarkText: '(владелец)',
  chatsGroupChatLeavePopupTitle: 'Покинуть чат',
  chatsGroupChatLeavePopupText: 'Вы уверены?',
  chatsGroupChatLeavePopupCancelButtonTitle: 'Отменить',
  chatsGroupChatLeavePopupConfirmButtonTitle: 'Подтвердить',
  chatDeleteGroupTitle: 'Удалить чат',
  chatDeleteGroupDescription: 'Чат и вся история чата будут удалены для всех его участников, продолжить?',
  chatDeleteGroupButtonTitleYes: 'Подтвердить',
  chatDeleteGroupButtonTitleNo: 'Отменить',
  chatsPrivateChatCurtainArchOptionTitle: 'Переместить в архив',
  chatsEditMessage: 'Редактировать сообщение',
  chatsCopyMessage: 'Копировать сообщение',
  chatsDeleteMessage: 'Удалить сообщение',
  chatsSelectMessage: 'Выбрать сообщение',
  chatMarkTextEdit: '(отредактировано)',
  chatCopyMessageAlertText: 'Сообщение скопировано!',
  chatDeleteMessageTitle: 'Удалить сообщение',
  chatDeleteMessageDescription: 'Удалить это сообщение?',
  chatDeleteMessageButtonTitleYes: 'Подтвердить',
  chatDeleteMessageButtonTitleNo: 'Отменить',
  chatSelectButtonDelete: 'Отменить',
  chatSelectButtonNo: 'Удалить',
  chatDeleteMessagesTitle: 'Удалить сообщения',
  chatDeleteMessagesDescription: 'Удалить эти сообщения?',
  chatDeleteMessagesButtonTitleYes: 'Подтвердить',
  chatDeleteMessagesButtonTitleNo: 'Отменить',
  chatArchiveButtonRestore: 'Восстановить',
  chatArchiveButtonNo: 'Удалить',
  chatNoUsersCurtainTitle: 'Упс!',
  chatsNoUsersCurtainText: 'Похоже, что вы единственный пользователь приложения. Пригласите друзей, чтобы начать общаться.',
  chatsNoUsersCurtainCancelButtonTitle: 'Отменить',
  chatsNoUsersCurtainCopyButtonTitle: 'Пригласить',
  chatsAppLinkCopiedAlertText: 'Ссылка скопирована!',
  chatsTooFewUsers: 'Для создания чата необходимо выбрать хотя бы одного пользователя!',
  chatsError: 'Что-то пошло не так!'
}
